
  // Reports array for each report type
  export const reportsByType = {
    IncidentReport: [
      'totalNumberOfIncidentsByStudent',
      'totalNumberOfIncidentsByYearGroup',
      'totalNumberOfIncidentsByStudentGroup',
      'totalNumberOfIncidentsByDate',
      'totalNumberOfIncidentsByHour',
      'totalNumberOfIncidentsByLocation',
      'totalNumberOfIncidentsBySystemUser',
      'totalNumberOfIncidents',
      'numberIncidentsPhysicalInterventionUsed',
      'numberIncidentsNoPhysicalInterventionUsed',
      'numberIncidentsRestrictedInterventionUsed',
      'relatedIncidents',
      'significantIncidents',
      'globalIncidentSearch'
    ],
    PILExtrasReport: [
      'pilExtrasByUserBullying',
      'pilExtrasByUserRacist',
      'pilExtrasByUserSexist',
      'pilExtrasByUserDisability',
      'pilExtrasByUserHomophobic',
      'pilExtrasByUserBiphobic',
      'pilExtrasByUserTransphobic',
      'pilExtrasByUserUseOfDerogatoryLanguage',
      'pilExtrasByUserSexualharassment',
      'pilExtrasByUserStudentOnStudent',
      'pilExtrasByUserSelfInjuriousBehaviour',
      'pilExtrasByUserAssaultOnStaff',
      'pilExtrasByUserSuspension',
      'pilExtrasByUserPermanentExclusion',
      'pilExtrasByUserAbsconding',
      'pilExtrasByUserUnsafeUseOfEquipment',
      'pilExtrasReport',
      'pilExtrasReportExclusions',
      'totalNumberOfIncidentsByYearGroup',
      'globalIncidentSearch'
    ],
    InvolvementReport: [
      // 'totalNumberOfIncidents',
      // 'numberOfStaffInvolvedPerIncident',
      'staffInvolvedInIncident',
      'otherChildrenInvolvedInIncident',
      // 'averageNumberOfStaffPerIncidentByDate',
      // 'totalNumberOfIncidentsByDate',
      // 'averageNumberOfStaffPerIncidentByHour',
      // 'averageNumberOfStaffPerIncidentByLocation',
      'globalIncidentSearch'
    ],
    MedicalInterventionReport: [
      'numIncidentsInvolvingInjuryToChild',
      'numIncidentsInvolvingInjuryToStaff',
      'numIncidentsInvolvingInjuryToOthers',
      // 'numIncidentsInvolvingInjuryByStudentGroup',
      // 'numIncidentsInvolvingInjuryWithOtherChildren',
      // // 'numberIncidentsRestrictedInterventionUsed',
      // 'totalNumberOfIncidentsByDate',
      // 'totalNumberOfIncidentsByHour',
      // 'averageNumberOfStaffPerIncidentByLocation',
      // 'otherChildrenInvolvedInIncident',
      'globalIncidentSearch'
    ],
    InterventionReport: [
      'commonIntervention',
      'commonTechnique',
      'commonDeescalationTechnique',
      'commonPhysicalTechnique',
      'incidentDamageCount',
      'numberIncidentsRestrictedInterventionUsed',
      'averageDurationPhysicalIntervention',
      'totalDurationPhysicalIntervention',
      'breathingMonitoredByStudentGraph',
      'breathingMonitoredByYearGroupGraph',
      'breathingMonitoredByStudentGroupGraph',
      'globalIncidentSearch'
    ],

    ConcernReport: [
      'concernSearch',
      'concernCount',
      'concernStudentCount',
      'concernByType',
      'concernByStudent',
      'concernByStudentPositive',
      'concernByStudentNegative',
      'concernByStudentNA',
      'concernStudentOverview',
      'globalIncidentSearch'
    ],

    ClickerReport: [
      'clickerSearch',
      'clickerCount',
      'clickerStudentCount',
      'clickerByType',
      'clickerByStudent',
      'clickerStudentOverview',
      'globalIncidentSearch'
    ]
  };
